export default (params) => ({
  trigger: {
    name: 'content_blocks.inspiration.select_highlight',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'inspirational_highlight',
      },
    },
  },
});
